import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Navigation from "./Navigation";
import AdminNavigation from "./AdminNavigation";
import { fetchUserData } from "utils/api";
import { useAuth } from "./AuthProvider";
import "styles/Dashboard.css";

const drawerWidth = 213;

const MainLayout = () => {
  const [userProfile, setUserProfile] = useState(null);
  const location = useLocation();
  const { groups } = useAuth();

  // Determine which navigation to show based on current path and user groups
  const getNavigationType = () => {
    if (location.pathname.startsWith("/admin")) {
      return "admin";
    }
    if (location.pathname.startsWith("/researcher")) {
      return "researcher";
    }
    if (
      location.pathname.startsWith("/biobank") ||
      location.pathname.startsWith("/dashboard")
    ) {
      return "biobank";
    }
    return "default";
  };

  const navigationType = getNavigationType();

  // Fetch profile on first load
  useEffect(() => {
    async function fetchProfile() {
      try {
        const profile = await fetchUserData();
        setUserProfile(profile);
      } catch (err) {
        console.error("Error fetching profile in MainLayout:", err);
        setUserProfile({});
      }
    }
    fetchProfile();
  }, []);

  if (userProfile === null && navigationType !== "admin") {
    return (
      <div className="dashboard-container">
        <Navigation userProfile={userProfile} />
        <div className="main-content">
          <p>Loading profile…</p>
        </div>
      </div>
    );
  }

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="main navigation"
      >
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              boxShadow: "2px 0 8px rgba(0, 0, 0, 0.2)",
            },
          }}
          open
        >
          {navigationType === "admin" ? (
            <AdminNavigation />
          ) : (
            <Navigation userProfile={userProfile} />
          )}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            p: 6,
            flexGrow: 1,
            "& > .MuiBox-root": {
              padding: "0 !important",
            },
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
